import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";


const styles = theme => ({
    // root: {},
});

@withStyles(styles)
class SelectionTab extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {};

    render() {
        const {classes} = this.props;

        return (
	<React.Fragment>
            <Typography component="div" style={{padding: 8 * 3}}>
                "Sec. Structure" : colored by secondary structure elements (helices in pink and strands in yellow).
            </Typography>
            <Typography component="div" style={{padding: 8 * 3}}>
                "RMS NOE viol" : side-chains colored by average RMS (Root Mean Square) of NOE violations (per residue) from green (low RMS) to red (high RMS).
            </Typography>
            <Typography component="div" style={{padding: 8 * 3}}>
                "RMSF bundle" : sausage representation with radius proportional to the Root Mean Square Fluctuation (per residue) in the ensemble.
            </Typography>
	</React.Fragment>
        );
    }
}

export default SelectionTab;